<template>
  <div class="main-container">
       <!-- Author: Siddhartha
      Date: 17/01/2020
      Issue Description: secondary nav view org tree  -->
        <breadcrumb :list="breadcrumbList" />
        <under-construction></under-construction>

    <div class="margintop-32 overlay">
     <h1>View Org Tree</h1>
    </div>
  </div>
</template>
<script>


export default {
  // name: "View Org Tree",

  data() {
    return {
      underDevelopment: true,
      breadcrumbList:[
              {
                name: "Organisation",
                url: `/dashboard/${this.$route.params.entity_index}/organisation`
              },
              {
                name: "View Org Tree",
                url: `/dashboard/${this.$route.params.entity_index}/`
              }
            ],

    };
  },
  methods: {
  routeToMainStep(main_step_name) {
      this.$router.push({
        path: `/dashboard/${this.$route.params.entity_index}/${main_step_name}`
      });
    },
    routeToSubStep(sub_step_name) {
      this.$router.push({
        path: `/dashboard/${this.$route.params.entity_index}/organisation/${sub_step_name}`
      });
    },
    createDocuments(){

    }
  }
};
</script>
<style scoped lang="scss">
@import "@/scss/components/margins.scss";
  .margin-top-16p{
    margin-top: 1.6%;
  }
  .margin-top-18 {
        margin-top: 18px;
    }

    .overlay{
      position: absolute;
    }
</style>
